import { Dropdown } from '../../../../common/Dropdown';
import { Form } from '../../../../common/FormWrapper';
import { LimitedMultiSelect } from '../../../../common/LimitedMultiSelectDropdown';
import { MultiSelect } from '../../../../common/MultiselectDropdown';
import { TagList } from '../../../../common/TagList';
import { TimePicker } from '../../../../common/TimePicker';
import { TeamSettingsReturn } from '../hooks/useTeamSettings';

export function TeamSettingsForm({
  form,
  isEditOn,
  userOptions,
  teamOptions,
  handleSave,
}: TeamSettingsReturn): JSX.Element {
  return (
    <Form
      className="flex flex-col gap-4 h-full"
      form={form}
      onSubmit={() => form.handleSubmit(handleSave)}
    >
      <div className="grid grid-cols-2 gap-4">
        <Dropdown
          name="teamName"
          label="Team Name"
          options={teamOptions}
          required
        />
        <Dropdown
          name="teamLead"
          label="Team Lead"
          options={userOptions}
          placeholder="Select team lead"
          required
          value={null}
          disabled={!isEditOn}
        />
        <TimePicker
          name="workHoursStart"
          interval={15}
          label="Work Hours Start"
          required
          disabled={!isEditOn}
        />
        <TimePicker
          name="workHoursEnd"
          interval={15}
          label="Work Hours End"
          required
          disabled={!isEditOn}
        />
        <MultiSelect
          name="teamMembers"
          label="Team Members"
          options={userOptions}
          placeholder="Select to add team members"
          required
          disabled={!isEditOn}
        />
        <LimitedMultiSelect
          name="checkInTimes"
          label="Check-In Times"
          required
          placeholder="Select 2 check-in times..."
          startTime="11:00"
          endTime="20:00"
          value={form.watch('checkInTimes')}
          disabled={!isEditOn}
        />
      </div>
      <TagList
        tags={form.watch('teamMembers')}
        disabled={!isEditOn}
        onRemove={(tagToRemove) => {
          if (!isEditOn) return;
          const currentMembers = form.watch('teamMembers');
          const updatedMembers = currentMembers.filter(
            (member) => member.id !== tagToRemove.id,
          );
          form.setValue('teamMembers', updatedMembers, {
            shouldValidate: true,
          });
        }}
      />
      <div className="grid grid-cols-2 gap-4 w-full">
        <Dropdown
          name="accountManager"
          label="Account Manager"
          options={userOptions}
          value={userOptions.find(
            (option) => option.id === form.getValues('accountManager')?.id,
          )}
          required
          disabled={!isEditOn}
          className="w-full"
        />
      </div>
    </Form>
  );
}
